import { ChangeEventHandler, ReactElement } from 'react';
import { IClassNameProps } from '@bem-react/core';

export enum InformerState {
    VIEWED = 'viewed'
}

export interface StreamScreenRateInformerLSItem {
    date: string;
    state: InformerState;
}

export interface StreamScreenRateInformerLS {
    [id: string]: StreamScreenRateInformerLSItem;
}

export interface StreamScreenRateInformerContainerProps {
    name: string;
    uri: string;
    stopTime: string;
    env: string;
}

export interface StreamScreenRateInformerProps extends IClassNameProps {
    rating: number;
    message: string;
    onClose: FunctionVoid;
    onRatingChange: (value: number) => void;
    onMessageChange: ChangeEventHandler<HTMLTextAreaElement>;
    replacer?: ReactElement;
    trailing?: ReactElement;
    actionButtons?: ReactElement;
}
